<template>
  <div class="wizard-body w-[75%] flex-shrink-0 flex-grow-0 max-w-[75%] height-three-rows">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.AUTH.TITLE')"
      :header-content="
        useInstallationName(
          $t('INBOX_MGMT.ADD.AUTH.DESC'),
          globalConfig.installationName
        )
      "
    />
    <div class="mt-6 mx-0 flex flex-wrap">
      <channel-item
        v-for="channel in channelList"
        :key="channel.key"
        :channel="channel"
        :enabled-features="enabledFeatures"
        @channel-item-click="initChannelAuth"
      />
    </div>
  </div>
</template>

<script>
import ChannelItem from 'dashboard/components/widgets/ChannelItem.vue';
import router from '../../../index';
import PageHeader from '../SettingsSubPageHeader.vue';
import { mapGetters } from 'vuex';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';

export default {
  components: {
    ChannelItem,
    PageHeader,
  },
  mixins: [globalConfigMixin],
  data() {
    return {
      enabledFeatures: {},
    };
  },
  computed: {
    account() {
      return this.$store.getters['accounts/getAccount'](this.accountId);
    },
    channelList() {
      const { apiChannelName, apiChannelThumbnail } = this.globalConfig;
      return [
        { key: 'api_whatsapp_select', name: 'WhatsApp' },
        { key: 'api_sms', name: 'SMS' },
        { key: 'website', name: 'Website' },
        // d99d 99hub — new-generation Meta inboxes routed through the 99Hub
        { key: 'hub_fb_page', name: this.$t('INBOX_MGMT.ADD.HUB.FB_PAGE.PICKER') },
        { key: 'hub_ig_page', name: this.$t('INBOX_MGMT.ADD.HUB.IG_PAGE.PICKER') },
        { key: 'hub_fb_messenger', name: this.$t('INBOX_MGMT.ADD.HUB.FB_MESSENGER.PICKER') },
        { key: 'hub_ig_messenger', name: this.$t('INBOX_MGMT.ADD.HUB.IG_MESSENGER.PICKER') },
        //{ key: 'whatsapp', name: 'WhatsApp' },
        // { key: 'sms', name: 'SMS' },
        { key: 'email', name: 'Email' },
        {
          key: 'api',
          name: apiChannelName || 'API',
          thumbnail: apiChannelThumbnail,
        },
        { key: 'telegram', name: 'Telegram' },
        { key: 'line', name: 'Line' },
        { key: 'tiktok', name: 'TikTok' },
        { key: 'api_incoming_calls', name: 'Call Logs' },
      ];
    },
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      globalConfig: 'globalConfig/get',
    }),
  },
  mounted() {
    this.initializeEnabledFeatures();
  },
  methods: {
    async initializeEnabledFeatures() {
      this.enabledFeatures = this.account.features;
    },
    initChannelAuth(channel) {
      const params = {
        page: 'new',
        sub_page: channel,
      };
      router.push({ name: 'settings_inboxes_page_channel', params });
    },
  },
};
</script>
<style scoped>
.height-three-rows {
  height: 900px;

  @media only screen and (max-width: 1440px) {
    height: 740px;
  }

  @media only screen and (max-width: 1024px) {
    height: 700px;
  }

  @media only screen and (max-width: 768px) {
    height: 120vh;
  }
}

.height-auto {
  height: auto;
}

.channel-list {
  margin-top: var(--space-medium);
}
</style>
